<template>
  <div
    :class="
      prop.ack ? [deviceType, 'containers-ack'] : [deviceType, 'containers']
    "
  >
    <div v-if="page != 'acknowledgement'" :class="[deviceType, 'frame-36470']">
      <div class="frame-1171275324">
        <img
          style="width: 20px; height: 24px; margin-right: 0"
          class="path-65"
          src="../../../../assets/icons/VirtualCC.svg"
        />
      </div>
      <p v-if="ack" :class="[deviceType, 'content']">
        {{ t("ccOnBoarding.virtualCCAck") }}
      </p>
      <div v-else :class="[deviceType, 'content']">
        {{ t("ccOnBoarding.virtualCC") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import i18n from "@/plugin/i18n";
import { deviceDetect } from "mobile-device-detect";
import { onMounted, onUnmounted } from "vue";
const deviceType = ref("");
const { t } = i18n.global;

const prop = defineProps({
  page: {
    type: String,
  },
  type: {
    type: String,
  },
  ack: {
    type: Boolean,
  },
  countDown: {
    type: String,
  },
});

const stickyElement = ref<HTMLElement | null>(null);
const isSticky = ref(false);

const handleScroll = () => {
  // console.log("window", window.scrollY);
  // console.log("test", stickyElement.value?.offsetTop);
  if (stickyElement.value) {
    isSticky.value = window.scrollY > 0;
  }
};

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }

  window.addEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.frame-36470,
.frame-36470 * {
  box-sizing: border-box;
}
.frame-36470 {
  background: #eaf7fe;
  border-radius: 8px;
  padding: 20px 40px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  width: auto;
  max-width: 1440px;
}

.frame-36470:is(.Mobile) {
  padding: 8px 16px;
}

.frame-1171275324 {
  display: flex;
  align-items: center;
}

.content {
  color: var(--web-black-medium, #212121);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-2-font-size, 14px);
  line-height: var(--subtitle-2-line-height, 130%);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  margin-bottom: 0;
}

.containers {
  padding: 20px 0px;
}

.containers-ack {
  padding: 20px 0px 0px 0px;
}

@media only screen and (max-width: 700px) {
  .containers,
  .containers-ack {
    padding: 10px 0px;
  }
}

.frame-36470:is(.Mobile) {
  border-radius: 8px;
}

.please-do-not-refresh-the-page-or-click-back-on-your-browser:is(.Mobile) {
  color: var(--web-black-medium, #212121);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit");
  font-size: var(--subtitle-2-font-size, 14px);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  flex: 1;
  width: 100%;
}

.containers:is(.Mobile) {
  padding: 0;
}
</style>
